<template>
  <auth-container
    :title="title"
    :description="config.texts.loginWelcomeDescription"
    :images="config.images.carousel"
    :mobileImages="config.images.carouselMobile"
  >
    <div class="access">
      <v-tabs
        hide-slider
        class="access__tabs"
        :fixed-tabs="mobile"
        light
        v-model="active"
      >
        <v-tab>Faça seu login</v-tab>
        <v-tab-item>
          <v-card>
            <v-card-text>
              <v-form ref="signIn" class="pt-4" @submit.prevent="signIn">
                <text-field
                  label="CPF ou CNPJ"
                  v-model="login.username"
                  :rules="rule.required"
                  :error-messages="error.username"
                  required
                  :mask="['###.###.###-##', '##.###.###/####-##']"
                ></text-field>

                <text-field
                  label="Senha"
                  v-model="login.password"
                  :rules="rule.required"
                  :error-messages="error.password"
                  type="password"
                  required
                ></text-field>

                <span class="access__keep-logged">
                  <v-checkbox
                    v-model="keepLogged"
                    label="Lembre-se de mim"
                    light
                  ></v-checkbox>
                </span>

                <v-layout>
                  <v-flex xs6>
                    <v-btn type="submit" color="green" class="btn-md">
                      <v-progress-circular
                        color="white"
                        indeterminate
                        v-if="loadingApp"
                      ></v-progress-circular>
                      <span v-else>Acessar</span>
                    </v-btn>
                  </v-flex>
                  <v-spacer v-if="!mobile" />
                  <v-flex xs5>
                    <v-btn
                      flat
                      small
                      class="access__forgot-password btn-md"
                      to="/esqueci-minha-senha"
                      >Esqueci minha senha</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab>Cadastre-se</v-tab>
        <v-tab-item>
          <v-card>
            <v-card-text>
              <p class="pb-4">
                Preencha os campos abaixo para habilitar o seu login.
              </p>

              <v-form ref="signUp" @submit.prevent="signUp">
                <text-field
                  label="CPF ou CNPJ"
                  v-model="register.username"
                  :mask="['###.###.###-##', '##.###.###/####-##']"
                  :error-messages="error.document"
                  :rules="rule.required"
                  required
                ></text-field>

                <v-btn type="submit" color="green" class="btn-md">
                  <v-progress-circular
                    color="white"
                    indeterminate
                    v-if="loadingApp"
                  ></v-progress-circular>
                  <span v-else>Criar login</span>
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab>Síndico</v-tab>
        <v-tab-item>
          <v-card>
            <v-card-text>
              <v-form
                ref="syndicSignIn"
                class="pt-4"
                @submit.prevent="syndicSignIn"
              >
                <text-field
                  label="CPF ou CNPJ"
                  v-model="login.username"
                  :rules="rule.required"
                  :error-messages="error.username"
                  required
                  :mask="['###.###.###-##', '##.###.###/####-##']"
                ></text-field>

                <text-field
                  label="Senha"
                  v-model="login.password"
                  :rules="rule.required"
                  :error-messages="error.password"
                  type="password"
                  required
                ></text-field>

                <span class="access__keep-logged">
                  <v-checkbox
                    v-model="keepLogged"
                    label="Lembre-se de mim"
                    light
                  ></v-checkbox>
                </span>

                <v-layout>
                  <v-flex xs6>
                    <v-btn type="submit" color="green" class="btn-md">
                      <v-progress-circular
                        color="white"
                        indeterminate
                        v-if="loadingApp"
                      ></v-progress-circular>
                      <span v-else>Acesso Síndico</span>
                    </v-btn>
                  </v-flex>
                  <v-spacer v-if="!mobile" />
                  <v-flex xs5>
                    <v-btn
                      flat
                      small
                      class="access__forgot-password btn-md"
                      :to="{ name: 'syndicForgotPassword' }"
                      >Esqueci minha senha</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </div>
  </auth-container>
</template>

<script>
import enums from '@/utils/enums';
import encrypt from '@/services/encrypt';
import TextField from '@/components/fields/TextField';
import AuthContainer from '@/components/auth/Container';
import { validateDocument } from '@/utils/documentValidation';
import { USER, CONFIG, UNIT, ROLES } from '@/utils/constants';
import { setToken, setAccessType, setDuplicatedEmail } from '@/services/auth';

export default {
  name: 'access',
  components: {
    AuthContainer,
    TextField,
  },
  computed: {
    config() {
      return this.$store.getters[CONFIG.GET];
    },
  },
  data() {
    return {
      active: null,
      title: 'Bem-vindo ao seu espaço!',
      titleColor: '#dd2e36',
      error: {},
      login: {
        username: '',
        password: '',
      },
      register: {
        username: '',
      },
      keepLogged: true,
    };
  },
  created() {
    if (this.$router.currentRoute.params.sendToSignUp) {
      this.login.username = this.$router.currentRoute.params.username;
      this.sendToSignUp();
    }
  },
  methods: {
    async syndicSignIn() {
      this.error = {};
      if (this.$refs.syndicSignIn.validate()) {
        if (!validateDocument(this.login.username)) {
          this.error = this.enums.responses.invalidUsername;
          return;
        }
        try {
          const url = `${process.env.AUTH_API_URL}/login`;
          const body = {
            username: this.stripNonNumeric(this.login.username),
            password: encrypt(this.login.password),
            userRole: ROLES.SYNDIC_ROLE,
          };
          const { token, user } = await this.requestService(
            url,
            'POST',
            {
              data: body,
              localErrorHandling: true
            }
          );

          setToken(token, { keepLogged: this.keepLogged });
          setAccessType(enums.accessTypes.login);

          this.$store.commit(USER.MUTATE_USER, user);
          await this.$store.dispatch(UNIT.SYNDIC_PRODUCTS, user);

          this.createTrace(this.enums.logTraceActions.login);
          this.$router.push({ name: 'syndicSelectProduct' });
        } catch (err) {
          if (
            err &&
            err.data &&
            err.data.message &&
            [
              'This user does not exist',
              'This user has not been verified',
            ].includes(err.data.message)
          ) {
            console.error(err.data.message);
          } else {
            console.error(err);
            this.error = this.handleAuthError(err);
          }
        }
      }
    },

    async signIn() {
      this.error = {};
      if (this.$refs.signIn.validate()) {
        if (!validateDocument(this.login.username)) {
          this.error = this.enums.responses.invalidUsername;
          return;
        }
        try {
          const url = `${process.env.AUTH_API_URL}/login`;
          const body = {
            username: this.stripNonNumeric(this.login.username),
            password: encrypt(this.login.password),
            userRole: ROLES.CLIENT_ROLE,
          };
          const { client, token, user, repeatedEmail } = await this.requestService(
            url,
            'POST',
            {
              data: body,
              localErrorHandling: true
            }
            
          );

          setToken(token, { keepLogged: this.keepLogged });
          setAccessType(enums.accessTypes.login);

          const { contracts, ...userData } = user;
          this.$store.commit(USER.MUTATE_USER, userData);

          if (contracts && contracts.length !== 0) {
            this.$store.commit(UNIT.MUTATE, contracts);
          }

          // Check duplicate e-mail
          if (repeatedEmail) {
            setDuplicatedEmail(repeatedEmail);
            this.$router.push({
              name: 'changeRepeatedEmail',
            });
            return;
          }

          this.createTrace(this.enums.logTraceActions.login);
          this.$router.push({ name: 'selectUnit' });
        } catch (err) {
          if (
            err &&
            err.data &&
            err.data.message &&
            (err.data.message == 'This user does not exist' ||
              err.data.message == 'This user has not been verified')
          ) {
            this.sendToSignUp();
          } else {
            this.error = this.handleAuthError(err);
          }
        }
      }
    },
    sendToSignUp() {
      this.active = 1;
      this.register.username = this.login.username;
      this.error.document =
        'Você não possui cadastro. Clique em "Criar login" para fazer o seu primeiro acesso.';
    },
    async signUp() {
      if (!this.loadingApp) {
        this.error = {};
        if (this.$refs.signUp.validate()) {
          if (!validateDocument(this.register.username)) {
            this.error = this.enums.responses.invalidUsername;
            return;
          }
          const url = `${process.env.AUTH_API_URL}/signUp`;
          const body = {
            userRole: ROLES.CLIENT_ROLE,
            username: this.stripNonNumeric(this.register.username),
          };
          try {
            const result = await this.requestService(
              url,
              'POST',
              {
                data: body,
                localErrorHandling: true,
                auth: false
              }
            );
            if (result) {
              const { user, repeatedEmail, tempToken } = result;
              // Check duplicate e-mail
              if (repeatedEmail) {
                const { contracts, ...userData } = user;
                setToken(tempToken, { keepLogged: false });
                setAccessType(enums.accessTypes.repeatedEmail);
                this.$store.commit(USER.MUTATE_USER, userData);

                if (contracts && contracts.length !== 0) {
                  this.$store.commit(UNIT.MUTATE, contracts);
                }

                setDuplicatedEmail(repeatedEmail);
                this.$router.push({
                  name: 'changeRepeatedEmail',
                });
                return;
              }

              this.$router.push({
                name: 'resetPassword',
                query: {
                  username: user.username,
                  email: user.email,
                },
              });
            }
          } catch (err) {
            this.error = this.handleAuthError(err);
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/scss/breakpoint';

.access {
  &__keep-logged {
    >>> .v-input--selection-controls {
      margin-top: 4px !important;
      margin-left: 4px !important;
      padding: 0 !important;
    }

    >>> .v-input--selection-controls__input {
      height: 14px !important;

      input {
        opacity: 1 !important;
        width: 16px !important;
        height: 16px !important;
      }

      i {
        display: none !important;
      }
    }
  }

  &__forgot-password {
    color: var(--brand-color) !important;
    font-weight: 400;
    @include breakpoint(mobile) {
      width: 80%;
    }
  }

  &__tabs {
    .v-tabs__bar {
      background-color: #f1f1f1ce !important;
      border-radius: 3px;
      height: 37.5px;
    }

    .v-tabs__div {
      font-weight: 400;
      font-size: 1em;
      text-transform: none;
      margin: 0;
      @include breakpoint(not-mobile) {
        width: 100%;
      }
    }

    .v-tabs__item {
      padding-bottom: 1em;
      color: var(--light-dark-color) !important;
      border-radius: 3px;
      box-shadow: var(--box-shadow);
      height: 50px;
    }

    .v-tabs__item--active {
      border-radius: 5px;
      color: var(--label-color) !important;
      background-color: #fff;
    }

    .v-tabs__icon {
      color: var(--light-dark-color) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue